import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col } from 'react-materialize';
import * as actions from '../../actions';
import './style.css';

class ChartToggle extends Component {
  componentDidMount() {
    const { $ } = window;
    const { toggleChart } = this.props;

    $('.switch-checkbox').on('change', function() {
      const value = $(this)[0].value;
      toggleChart(value);
    });
  }

  render() {
    return(
      <Col s={6} m={6} l={1} className="hide-on-small-only" style={{ height: 37, marginTop: 5 }}>
        <div className="switch">
          <div className="switch-label"><label style={{whiteSpace: 'nowrap'}}>Full-size Chart</label></div>
          <label>
            <input type="checkbox" className="switch-checkbox" value={ this.props.chartToggle } />
            <span className="lever"></span>
          </label>
        </div>
      </Col>
    )
  }
}

function mapStateToProps({ chartToggle }) {
  return { chartToggle };
}

export default connect(mapStateToProps, actions)(ChartToggle);



// WEBPACK FOOTER //
// ./src/components/Dashboard/ChartToggle.js